import moment from "moment";
export const eventDateDisplay = (value) => {
  const date = moment(value, moment.ISO_8601, true);
  return value && date.isValid()
    ? date.utcOffset(480).format("YYYY-MM-DD HH:mm:ss")
    : "—";
};
export const eventDateInput = (value) => {
  const date = moment(value, moment.ISO_8601, true);
  return value && date.isValid()
    ? date.utcOffset(480).format("YYYY-MM-DDTHH:mm")
    : "";
};
export const eventModel = (data = {}) => ({
  uuid: data.uuid,
  name: data.name || data.title || "",
  description: data.description || "",
  coverImage: data.cover_image || "",
  keywords: Array.isArray(data.keywords)
    ? data.keywords.filter((item) => typeof item === "string")
    : [],
  venueType: data.venue_type == null ? null : Number(data.venue_type),
  venueName: data.venue_display_name || "",
  venueLink: data.venue_link || "",
  link: data.link || "",
  startedAt: data.started_at || "",
  endedAt: data.ended_at || "",
  registrationClosedAt: data.registration_closed_at || "",
  startedAtDisplay: eventDateDisplay(data.started_at),
  endedAtDisplay: eventDateDisplay(data.ended_at),
  createdAtDisplay: eventDateDisplay(data.created_at),
  capacity: data.capacity ?? "",
  registrationEnabled: [true, 1, "1"].includes(data.is_registration_enabled),
  isActive: [true, 1, "1"].includes(data.is_active),
  company: data.company?.uuid
    ? { value: data.company.uuid, text: data.company.name || data.company.uuid }
    : null,
  picUser: data.pic_user?.uuid
    ? {
        value: data.pic_user.uuid,
        text:
          data.pic_user.name ||
          [data.pic_user.first_name, data.pic_user.last_name]
            .filter(Boolean)
            .join(" ") ||
          data.pic_user.email ||
          data.pic_user.uuid,
      }
    : null,
  eventStatus: data.event_status?.name || "",
  joinedCount: Number(data.joined_count) || 0,
});
